<template>
  <div class="unit-page fullWidth">
    <div class="unitPageForm">
      <br />
      <router-link :to="'/' + 'units/' + $i18n.locale">
        <div class="close"></div>
      </router-link>
      <div class="unitData">
        <br />
        <h3>
          <span
            class="field-value active"
            v-show="!showField('name')"
            @click="focusField('name')"
            >{{ unit.name }}</span
          >
          <input
            v-show="showField('name')"
            class="field-value form-control inactive"
            v-model="unit.name"
            type="text"
            maxlength="35"
            @focus="focusField('name')"
            @blur="
              $v.unit.name.$touch()
              blurField('name')
            "
          />
        </h3>
        <template v-if="$v.unit.name.$error">
          <div v-if="!$v.unit.name.required" class="errorMessage2">
            {{ $t('unitNameReq') }}
          </div>
        </template>
        <template v-if="$v.unit.name.$invalid">
          <div v-if="!$v.unit.name.maxLength" class="errorMessage1">
            {{ $t('unitNameLength') }}
          </div>
        </template>
        <div>
          <span>{{ $t('fullAddress') }} </span>
          <br />
          <span
            class="field-value active"
            v-show="!showField('address')"
            @click="focusField('address')"
            >{{ unit.address }}</span
          >
          <input
            v-show="showField('address')"
            class="field-value form-control inactive"
            v-model="unit.address"
            type="text"
            ref="autocomplete"
            id="address"
            maxlength="152"
            @focus="focusField('address')"
            @blur="
              $v.unit.address.$touch()
              blurField('address')
            "
          />
          <template v-if="$v.unit.address.$invalid">
            <div v-if="!$v.unit.address.maxLength" class="errorMessage1">
              {{ $t('fullAddressLength') }}
            </div>
          </template>
        </div>
        <br />
        <br />
        <div>
          <span>{{ $t('appNo') }} ({{ $t('optional') }}) </span>
          <br />
          <input
            v-show="!showField('app_no')"
            class="field-value active"
            placeholder="Empty"
            v-model="unit.app_no"
            @click="focusField('app_no')"
          />
          <input
            v-show="showField('app_no')"
            class="field-value form-control inactive"
            v-model="unit.app_no"
            type="number"
            maxlength="3"
            @focus="focusField('app_no')"
            @blur="
              $v.unit.app_no.$touch()
              blurField('app_no')
            "
          />
        </div>
        <br />
        <span>{{ $t('unitInfo') }} </span>
        <div>
          <br />
          <textarea
            v-show="!showField('comments')"
            class="field-value active"
            placeholder="Empty"
            v-model="unit.comments"
            @click="focusField('comments')"
          ></textarea>
          <textarea
            v-show="showField('comments')"
            class="field-value form-control inactive"
            v-model="unit.comments"
            type="textarea"
            maxlength="250"
            @focus="focusField('comments')"
            @blur="
              $v.unit.comments.$touch()
              blurField('comments')
            "
          ></textarea>
        </div>
        <template v-if="$v.unit.comments.$invalid">
          <p v-if="!$v.unit.comments.maxLength" class="errorMessage1">
            {{ $t('unitDescLength') }}
          </p>
        </template>
        <br />
      </div>
      <p class="editInstructions">{{ $t('editInstructions') }}</p>
      <br />
      <hr />
    </div>
    <h2>{{ $t('unitStore') }}</h2>
    <ToggleServiceProduct @type-changed="selectType" />
    <!-- PULSE ICON -->
    <div
      class="container"
      @click="
        showUnitProduct
          ? $bvModal.show('modal')
          : $bvModal.show('modal-experience')
      "
    >
      <div class="pulse">
        <svg
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 60.364 60.364"
          style="enable-background:new 0 0 60.364 60.364;"
          xml:space="preserve"
        >
          <g>
            <path
              fill="#fff"
              d="M54.454,23.18l-18.609-0.002L35.844,5.91C35.845,2.646,33.198,0,29.934,0c-3.263,0-5.909,2.646-5.909,5.91v17.269
				L5.91,23.178C2.646,23.179,0,25.825,0,29.088c0.002,3.264,2.646,5.909,5.91,5.909h18.115v19.457c0,3.267,2.646,5.91,5.91,5.91
				c3.264,0,5.909-2.646,5.91-5.908V34.997h18.611c3.262,0,5.908-2.645,5.908-5.907C60.367,25.824,57.718,23.178,54.454,23.18z"
            />
          </g>
        </svg>
      </div>
    </div>
    <!-- end of PULSE ICON -->

    <a
      download
      data-filesize="pdf"
      class="download-button"
      v-if="showUnitProduct && unitProduct.unitProducts.length > 0"
      @click="downloadProductPDF"
    >
      {{ $t('exportProducts') }}
    </a>

    <a class="download-button" @click="openSelectBoxForQRCodeLayoutModal">
      {{ $t('exportAllUnitProductsQRCodes') }}
    </a>
    <a
      download
      data-filesize="pdf"
      class="download-button"
      v-if="!showUnitProduct && experience.unitExperiences.length > 0"
      @click="downloadExperiencePDF"
    >
      {{ $t('exportExperiences') }}
    </a>
    <ToggleCatalogueStyle
      @change-toggle="changeFeaturedToggleValue"
    ></ToggleCatalogueStyle>
    <div v-if="showUnitProduct">
      <SearchFilter
        v-if="
          !(isSearchResult === false && unitProduct.unitProducts.length === 0)
        "
      />

      <div
        v-if="isSearchResult === true && unitProduct.unitProducts.length === 0"
      >
        {{ $t('noSearchResult') }}
      </div>

      <div
        v-else-if="
          isSearchResult === false && unitProduct.unitProducts.length === 0
        "
        class="unitProductsEmpty"
      >
        <br />
        <figure class="about-img2 img-wrapper">
          <img src="../assets/static/images/illustrations/product.svg" />
        </figure>
        <!-- <p>{{ $t('addFirstProductToUnitTooltip') }}
			<button class="add-btn" @click="$bvModal.show('modal')">
				{{ $t('addProductToUnit') }}
			</button>
			</p> -->
      </div>

      <div v-else class="activeClient">
        <transition-group class="column" name="fade" tag="ul" appear>
          <UnitProductCard
            v-show="featured === false"
            v-for="unitProduct in unitProduct.unitProducts"
            :key="(unitProduct.unit_id, unitProduct.product_id)"
            :unitProduct="unitProduct"
          />
          <UnitProductCardFeatured
            v-show="featured === true"
            v-for="unitProduct in unitProduct.unitProducts"
            :key="(unitProduct.unit_id, unitProduct.product_id)"
            :unitProduct="unitProduct"
          />
        </transition-group>
      </div>
    </div>
    <div v-else>
      <SearchFilter
        v-if="
          !(isSearchResult === false && experience.unitExperiences.length === 0)
        "
      />
      <div
        v-if="
          isSearchResult === true && experience.unitExperiences.length === 0
        "
      >
        {{ $t('noSearchResult') }}
      </div>
      <div
        v-if="
          isSearchResult === false && experience.unitExperiences.length === 0
        "
        class="unitProductsEmpty"
      >
        <br />
        <figure class="about-img2 img-wrapper">
          <img src="../assets/static/images/illustrations/product.svg" />
        </figure>
        <!-- <p>
			<button class="add-btn" @click="$bvModal.show('modal-experience')">
				{{ $t('addExperienceToUnit') }}
			</button>
			</p> -->
      </div>

      <div v-else class="activeClient">
        <transition-group
          class="product-cards column"
          name="fade"
          tag="ul"
          appear
        >
          <UnitExperienceCard
            v-show="featured === false"
            v-for="unitExperience in experience.unitExperiences"
            :key="(unitExperience.unit_id, unitExperience.experience_id)"
            :unitExperience="unitExperience"
          />
          <UnitExperienceCardFeatured
            v-show="featured === true"
            v-for="unitExperience in experience.unitExperiences"
            :key="(unitExperience.unit_id, unitExperience.experience_id)"
            :unitExperience="unitExperience"
          />
        </transition-group>
      </div>
    </div>
    <br />
    <div class="trash-btn" @click="deleteUnit">
      <div>
        <font-awesome-icon class="icon" icon="trash" /><span>
          {{ $t('removeUnit') }}</span
        >
      </div>
    </div>
    <ConfirmDialog
      :visible="showConfirmation"
      class="customClass"
    ></ConfirmDialog>
    <b-modal id="modal" hide-footer>
      <template v-slot:modal-title>
        {{ $t('addProductToUnit') }}
      </template>
      <UnitProductCreateModal />
    </b-modal>
    <b-modal id="modal-experience" hide-footer>
      <template v-slot:modal-title>
        {{ $t('addExperienceToUnit') }}
      </template>
      <UnitExperienceCreateModal />
    </b-modal>
    <b-modal id="SelectBoxForQRCodeLayout-modal" size="lg" hide-footer>
      <template v-slot:modal-title>
        <SelectBoxForQRCodeLayout 
          type="UNIT"
          :unit="unit"
          @close-modal="closeSelectBoxForQRCodeLayout"
        />
      </template>
    </b-modal>
  </div>
</template>

<script>
import UnitProductCard from '@/components/ui/UnitProductCard.vue'
import UnitProductCardFeatured from '@/components/ui/UnitProductCardFeatured.vue'
import UnitExperienceCard from '@/components/ui/UnitExperienceCard.vue'
import UnitExperienceCardFeatured from '@/components/ui/UnitExperienceCardFeatured.vue'
import UnitProductCreateModal from '@/components/ui/UnitProductCreateModal.vue'
import UnitExperienceCreateModal from '@/components/ui/UnitExperienceCreateModal.vue'
import SelectBoxForQRCodeLayout from '@/components/forms/SelectBoxForQRCodeLayout.vue'
import SearchFilter from '@/components/common/SearchFilter.vue'
import { mapState } from 'vuex'
import { required, maxLength } from 'vuelidate/lib/validators'
import ToggleServiceProduct from '@/components/common/ToggleServiceProduct.vue'
import ToggleCatalogueStyle from '@/components/common/ToggleCatalogueStyle.vue'
import MarketPlaceService from '@/services/MarketPlaceService.js'
import ConfirmDialog from 'primevue/confirmdialog'

export default {
  metaInfo() {
    return {
      title: this.title,
      isSearchResult: false
    }
  },
  components: {
    UnitProductCard,
    UnitProductCardFeatured,
    UnitProductCreateModal,
    ToggleServiceProduct,
    ToggleCatalogueStyle,
    UnitExperienceCreateModal,
    UnitExperienceCard,
    UnitExperienceCardFeatured,
    SearchFilter,
    SelectBoxForQRCodeLayout,
    ConfirmDialog
  },
  data() {
    return {
      title: 'Unit',
      id: this.unit.id,
      isEditing: false,
      isActive: false,
      showUnitProduct: true,
      featured: false,
      showConfirmation: false,
      vueQuickEditClasses: {
        wrapper: 'form-group form-inline',
        input: 'formControl input-sm',
        buttons: 'btn-group btn-group-sm',
        buttonOk: 'btn saveBtn',
        buttonCancel: 'btn closeBtn'
      },
      vueQuickEditClassesTitleName: {
        wrapper: 'form-group titleName form-inline',
        input: 'formControl input-sm',
        buttons: 'btn-group btn-group-sm',
        buttonOk: 'btn saveBtn',
        buttonCancel: 'btn closeBtn'
      },
      vueQuickEditClassesShortInput: {
        wrapper: 'form-group form-inline',
        input: 'formControl short input-sm',
        buttons: 'btn-group btn-group-sm',
        buttonOk: 'btn saveBtn',
        buttonCancel: 'btn closeBtn'
      },
      vueQuickEditClassesTextArea: {
        wrapper: 'form-group form-inline textBoxArea',
        input: 'formControl addInfoArea input-sm',
        buttons: 'btn-group btn-group-sm',
        buttonOk: 'btn saveBtn',
        buttonCancel: 'btn closeBtn'
      },
      editField: ''
    }
  },
  validations: {
    unit: {
      name: { required, maxLength: maxLength(20) },
      address: { required, maxLength: maxLength(150) },
      // postal_code: {},
      app_no: {},
      comments: { maxLength: maxLength(250) }
    }
  },
  async mounted() {
    this.isSearchResult = false
    this.widget = new window.google.maps.places.Autocomplete(
      document.getElementById('address'),
      { types: ['geocode'] }
    )
    this.widget.addListener('place_changed', () => {
      this.editField = ''
      this.unit.address = document.getElementById('address').value
      this.changeUnitDetails('address')
    })
  },
  created() {
    this.$store.dispatch('unitProduct/fetchUnitProducts', this.id)
    this.$store.dispatch('experience/fetchUnitExperiences', this.id)
    this.title = this.unit.name
  },
  computed: mapState(['unitProduct', 'client', 'experience']),
  methods: {
    focusField(name) {
      this.editField = name
    },
    blurField(name) {
      this.editField = ''
      if (name !== 'address') {
        this.changeUnitDetails(name)
      }
    },
    showField(name) {
      return this.unit[name] == '' || this.editField == name
    },
    selectType(value) {
      this.showUnitProduct = value
    },
    openSelectBoxForQRCodeLayoutModal() {
      this.$bvModal.show('SelectBoxForQRCodeLayout-modal')
    },
    closeSelectBoxForQRCodeLayout() {
      this.$bvModal.hide('SelectBoxForQRCodeLayout-modal')
    },
    deleteUnit() {
      this.$confirm.require({
        message: this.$t('confirmUnitDelete'),
        header: this.$t('areYouSure'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        accept: () => {
          this.$store.dispatch('unit/removeUnit', this.id).then(() => {
            this.$router.push({
              path: '/units/en'
            })
          })
        },
        reject: () => {
          this.showConfirmation = false
        }
      })
    },
    changeUnitDetails(propertyName) {
      if (this.unit[propertyName] === '') {
        return
      }
      // if (confirm('are you sure? This will rewrite excisting unit details'))
      {
        this.$store.dispatch('unit/editUnit', this.unit)
        this.isEditing = !this.isEditing
        this.isActive = !this.isActive
      }
    },
    async searchTerm(search) {
      const searchJson = {
        id: this.id,
        search
      }
      if (this.showUnitProduct)
        await this.$store.dispatch('unitProduct/searchUnitProducts', searchJson)
      else
        await this.$store.dispatch(
          'experience/searchUnitExperiences',
          searchJson
        )
      this.isSearchResult = true
    },
    clearSearch() {
      if (this.showUnitProduct)
        this.$store.dispatch('unitProduct/fetchUnitProducts', this.id)
      else this.$store.dispatch('experience/fetchUnitExperiences', this.id)
      this.isSearchResult = false
    },
    downloadExperiencePDF() {
      MarketPlaceService.downloadExperienceListPDF({
        unit_id: this.id,
        featured: this.featured
      }).then(response => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]))
        var fileLink = document.createElement('a')

        fileLink.href = fileURL
        fileLink.setAttribute(
          'download',
          `Experience_list-${this.unit.name}.pdf`
        )
        document.body.appendChild(fileLink)

        fileLink.click()
      })
    },
    downloadProductPDF() {
      MarketPlaceService.downloadProductListPDF({
        unit_id: this.id,
        featured: this.featured
      }).then(response => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]))
        var fileLink = document.createElement('a')

        fileLink.href = fileURL
        fileLink.setAttribute('download', `Product_list-${this.unit.name}.pdf`)
        document.body.appendChild(fileLink)

        fileLink.click()
      })
    },
    changeFeaturedToggleValue(value) {
      this.featured = value
    }
  },
  props: {
    unit: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.fullWidth {
  width: 100%;
}

.unitProductsEmpty {
  // display: none; //! none when FIRST unitProduct with this client_id is already found in db //
}
.activeClient {
  // display: none; //! none when NO unitProduct with this client_id is found in db //
  margin: 0;
}
.column {
  display: flex;
  flex-flow: wrap;
  height: 100%;
  justify-content: center;
}

/** Download button styling */
.download-button {
  display: inline-block;
  margin: 30px 20px;
  padding: 30px 30px 30px 80px;
  color: #969696;
  text-decoration: none;
  border: 1px solid #e3e3e3;
  position: relative;
  transition: 0.15s;
  letter-spacing: 1px;
  font-weight: 600;
  text-transform: uppercase;
}

.download-button:focus,
.download-button:hover {
  border-color: var(--primaryDark);
  background-color: rgba(201, 92, 95, 0.15);
  outline: none;
}

.download-button:active {
  animation: enlight 0.5s;
  border-color: var(--primaryDark);
  background-color: rgba(201, 92, 95, 0.15);
}

.download-button::before {
  content: ''; /* 1 */
  background: url('https://s3-us-west-2.amazonaws.com/s.cdpn.io/2037/download.svg')
    no-repeat center; /* 2 */
  position: absolute; /* 3 */
  top: 0; /* 4 */
  bottom: 0; /* 4 */
  left: 0; /* 5 */
  width: 80px; /* 6 */
}

.download-button[data-filesize]::after {
  content: '(' attr(data-filesize) ')'; /* 1 */
  font-size: 0.8em; /* 2 */
  color: #969696; /* 3 */
  margin-left: 10px; /* 4 */
}

/**
 * Active animation, playing with box-shadow
 */
@keyframes enlight {
  to {
    box-shadow: 0 0 0 8px #fce8ed;
  }
}
/** END OF DOWNLOAD BTN STYLING */

.unitPageForm {
  width: 45%;
  margin: auto;
  text-align: left;
}
.unitData {
  background: var(--grey-light);
  padding: 30px;
  border-radius: 15px;
}

.errorMessage {
  margin-top: -15px;
  margin-bottom: 0.2em;
  padding-left: 5px;
  padding-top: 4px;
  color: var(--primaryDark);
  font-size: 0.58em;
  z-index: -1;
}
.errorMessage2 {
  margin-top: -22px;
  margin-bottom: 0.2em;
  padding-left: 5px;
  padding-top: 4px;
  color: var(--primaryDark);
  font-size: 0.58em;
  z-index: -1;
}
.errorMessage1 {
  margin-bottom: 0.2em;
  color: var(--primaryDark);
  font-size: 0.58em;
}

.add-btn {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 1em;
  letter-spacing: 3px;
  width: 30%;
  border-radius: 5px;
}
.add-btn2 {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 1em;
  border-radius: 5px;
  letter-spacing: 3px;
  width: 100%;
}

button:disabled,
button[disabled] {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.countryStatic {
  color: var(--bg) !important;
  font-weight: 600;
  font-size: 1.2em;
}

.bgColor {
  color: var(--bg);
}

.editInstructions {
  color: var(--grey);
  font-size: 0.8em;
  text-align: center;
}

.trash-btn {
  background-color: var(--primaryDark);
  cursor: pointer;
  color: var(--bright);
  padding: 5px;
  letter-spacing: 3px;
  border: none !important;
  border-radius: 3.5px;
  margin: auto;
  width: 15em;
  height: 32px;
}

.inputStyle {
  margin-bottom: 24px;
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  background-color: #fff;
  background-clip: padding-box;
}
.field {
  margin-bottom: 24px;
}

.close {
  position: absolute;
  right: 35px;
  top: 25px;
  width: 25px;
  height: 25px;
  opacity: 0.3;
}
.close:hover {
  opacity: 1;
}
.close:before,
.close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
.about-img2 {
  display: inline-block;
  width: 100%;
  max-width: 250px;
  text-align: center;
  vertical-align: top;
}

.unitName {
  text-align: center;
  font-size: 3em;
  width: 100%;
}

textarea {
  width: 100%;
  height: 180px;
  margin-top: -20px;
  padding-left: 0;
  padding-right: 15px;
}

//PULSE ICON CSS sytling //
@keyframes pulse {
  0% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(251, 115, 119, 0.7), 0 0 0 0 rgba(201, 92, 95, 0.7);
  }
  40% {
    transform: scale(1);
    box-shadow: 0 0 0 40px rgba(251, 115, 119, 0),
      0 0 0 0 rgba(201, 92, 95, 0.7);
  }
  80% {
    transform: scale(1);
    box-shadow: 0 0 0 40px rgba(251, 115, 119, 0),
      0 0 0 20px rgba(201, 92, 95, 0);
  }
  100% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(251, 115, 119, 0.7),
      0 0 0 20px rgba(201, 92, 95, 0);
  }
}

div[class^='pulse'] {
  background: var(--primaryDark);
  border-radius: 50%;
  color: white;
  cursor: pointer;
  height: auto;
  margin: auto;
  padding: 1.2em;
  text-align: center;
  width: 60px;
}

.pulse:active {
  animation: pulse 0.25s infinite ease-out;
}
.pulse:hover {
  background: #c95c5f;
}
// ------- ///

@media screen and (max-width: 560px) {
  textarea {
    width: 100%;
    height: 250px;
  }
  .unitPage {
    margin: 10px;
  }
  .unitPageForm {
    width: 90%;
  }
  .unitData {
    padding: 20px;
  }
  .field {
    margin-bottom: 4px;
  }
  .column {
    display: inherit;
    padding: inherit;
  }
  .close {
    right: 45px;
    top: 45px;
  }
}

@media screen and (max-width: 450px) {
  .unitName {
    margin-top: 10px;
    font-size: 2em;
    font-weight: 600;
  }
  .trash-btn {
    width: auto;
    margin: 0 40px;
  }
  .editInstructions {
    text-align: left;
    margin-left: 8px;
  }
}

@media screen and (max-width: 400px) {
  textarea {
    height: 100px;
  }
}

.save-btn {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 0.4em;
  margin: auto !important;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  height: 38px;
  text-align: center;
  width: 120px;
}

.save-btn-box {
  margin: auto;
}

.edit-btn {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 0.5em;
  margin: auto !important;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 230px;
  height: 40px;
  cursor: pointer;
}

.icon {
  font-size: 1.3em;
  padding: 1px;
}
.active {
  border-radius: 3.5px;
  width: 100%;
  background: none !important;
  font-weight: 600;
  font-style: normal !important;
}
.inactive {
  background-color: var(--primarySuperLight);
  border-radius: 3.5px;
  font-style: italic;
}
.product-list {
  margin-top: 70px;
}
.product-cards {
  margin-top: 20px;
}

::-webkit-input-placeholder {
  color: #ff6961;
}
:-moz-placeholder {
  color: #ff6961;
}
::-moz-placeholder {
  color: #ff6961;
}
:-ms-input-placeholder {
  color: #ff6961;
}

@media screen and (max-width: 780px) {
  .unitName {
    font-size: 2em;
    text-align: center;
  }
  .add-btn {
    width: 80%;
  }
  .add-btn2 {
    margin-top: 20px;
  }
}

@media screen and (min-width: 800px) {
  .unitData {
    width: 90%;
    margin: auto;
  }
}

@media screen and (orientation: landscape) and (min-device-width: 319px) and (max-device-width: 680px) {
  .unitPageForm {
    width: 90%;
  }
}
</style>
